import { Component, OnInit, Input, ViewChild, Output, EventEmitter } from '@angular/core';
import { BaseComponent } from '../../Library/BaseComponent';
import { ComplainRegister, StaffAssignmentFilter, GuestInvDetails, JobInventoryLocationsDetails } from '../../Models/RequestModels';
import { MasterDataService } from '../../Services/MasterDataService';
import { ActivatedRoute, Router } from '@angular/router';
import { CallStatuses, EntityCodes, JobOperationActions, InventoryItemTypes, InventoryItemType, InventoryTransactionTypes } from '../../Models/EnumModels';
import { PMSService } from '../../Services/PMSService';
import { GuestLookup, Staff_Search_Assigment } from '../../Models/ResponseModels';
import * as _ from 'lodash';
import { ComplainService } from '../../Services/ComplainService';
import { CallDescriptionLookup, CallCategoryLookup, LocationLookup } from '../../Models/GlobalEntities';
import { NgbModal, NgbActiveModal, NgbModalRef, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../../Services/UserService';
import { ParkEntry } from '../ParkEntry/ParkEntry';
import { ManualAssign } from '../ManualAssign/ManualAssign';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

@Component({
    selector: 'JobOperations',
    templateUrl: './JobOperations.html'
})

export class JobOperations extends BaseComponent implements OnInit {
    @ViewChild('content') content;
    @ViewChild('parkEntry') parkEntry: ParkEntry;
    @ViewChild("manualAssign") manualAssign: ManualAssign;
    @ViewChild('confirm') confirm;
    Mode: JobOperationActions;
    ModalRef: NgbModalRef;
    Title: string;
    Model: ComplainRegister;
    @Input() ComplainId: number;
    _JobOperationActions = JobOperationActions;
    _CallStatuses = CallStatuses;
    AssignToName: string = "";

    Reset_Hours: number = 0;
    Reset_Minutes: number = 0;

    ConfirmModalRef: NgbModalRef;
    ConfirmModel: Array<any>;
    JobData: any;
    guestInventoryDetail = new GuestInvDetails();
    JobInventoryLocations = new JobInventoryLocationsDetails();
    inventorySingularityEnabled: boolean = false;
    inventoryItempType: string = '';
    InventoryItemType = InventoryItemType;

    constructor(public translate: TranslateService, public toastr: ToastrService, public route: ActivatedRoute, public router: Router, public masterService: MasterDataService, protected userService: UserService, public complainService: ComplainService, private modalService: NgbModal) {
        super(translate, toastr, route, router, masterService);
    }

    ngOnInit(): void {

    }

    onOpen(Mode: JobOperationActions, Model: ComplainRegister, JobData:any): void {
        this.Model = _.cloneDeep(Model);
        this.Model.Operation = Mode;
        this.Mode = Mode;
        this.Model.ClosedReasonCode = 0;
        this.Model.Remarks = null;
        this.Model.LastActionRemarks = null;
        this.Reset_Hours = 0;
        this.Reset_Minutes = 0;
        this.ClearErrors();
        if (JobData) {
            this.JobData = JobData;
        }

        switch (this.Mode) {
            case JobOperationActions.Close:
                if(this.inventorySingularityEnabled){
                    this.setInventoryItemType();
                    this.getInventoryData();
                }
                this.Title = 'TITLE.TITLE_CLOSE_JOB';
                break;
            
            case JobOperationActions.Park:
                this.Title = 'TITLE.TITLE_PARK_JOB';
                //this.parkEntry.Model = this.Model;
                break;
            case JobOperationActions.Reopen:
                this.Title = 'TITLE.TITLE_REOPEN_JOB';
                //this.jobOperations.onOpen(Mode);
                break;
            case JobOperationActions.Reset:
                this.Title = 'TITLE.TITLE_RESET_JOB';
                //this.jobOperations.onOpen(Mode);
                break;
            case JobOperationActions.AddRemarks:
                this.Title = 'TITLE.TITLE_ADD_REMARK';
                //this.jobOperations.onOpen(Mode);
                break;
        }
        let ngbModalOptions: NgbModalOptions = {
            backdrop : 'static',
            size: 'lg'
        };
        this.ModalRef = this.modalService.open(this.content, ngbModalOptions);
    }

    getInventoryData(){
       let invData =  this.masterService.getInventoryDetailByPropertyDescription(this.Model.PropertyId, this.Model.CallDescriptionsId);
        this.Model['InventoryJobMappings'] = invData;
    }

    onAssignmentChange(): void {
        if (this.Model.IsAutoAssign == false) {
            this.manualAssign.RequestModel = new ComplainRegister();
            this.manualAssign.OpenForAssignment(this.Model.CallDescriptionsId, this.Model.LocationId, this.Model.PropertyId, this.JobData);
        }
    }

    onSelectedStaff(StaffId: number): void {
        if (StaffId == null) {
            this.Model.IsAutoAssign = true;
            this.AssignToName = null;
            this.Model.AssignedTo = null;
            return;
        }

        this.Model.AssignedTo = StaffId;
        this.AssignToName = this.masterService.MasterData_GetMutli(this.Model.PropertyId, this.Model.AssignedTo, EntityCodes.Staff, this.Model.AssignedTo.toString());
    }

    ValidateClose(): void {
        if (this.Model.ClosedReasonCode == null || +this.Model.ClosedReasonCode <= 0) {
            this.AddError('ERR.ERR_SELECT_CLOSING_REASON');
        }
        if ( this.inventorySingularityEnabled && this.Model && this.Model.InventoryJobMappings) {
            if( (this.inventoryItempType == InventoryItemType.Reusable || this.inventoryItempType == InventoryItemType.Consumables) && this.Model.InventoryJobMappings.DefaultQuantity == null || +this.Model.InventoryJobMappings.DefaultQuantity <= 0){
                this.AddError('ERR.ERR_QUANTITY_NOT_LESS_THAN_1');
            }
            if( this.inventoryItempType == InventoryItemType.Reusable && this.Model.InventoryJobMappings.StockLocationId == null){
                this.AddError('ERR.ERR_STORE_LOCATION_MANDATORY');
            }

            if( this.inventoryItempType == InventoryItemType.Reusable && this.guestInventoryDetail.GuestCheckInAt == null){
                this.AddError('ERR.ERR_INV_CHECK_IN_MANDATORY');
            }

            if( this.inventoryItempType == InventoryItemType.Reusable && this.guestInventoryDetail.GuestCheckOutAt == null){
                this.AddError('ERR.ERR_INV_CHECK_OUT_MANDATORY');
            }
        }
    }

    ValidatePark(): void {
        let cDate = new Date();

        if (this.Model.ClosedReasonCode == null || this.Model.ClosedReasonCode <= 0) {
            this.AddError('ERR.ERR_SELECT_PARKING_REASON');
        }

        if (this.Model.ReopenTime == null) {
            this.AddError('ERR.ERR_REQ_REOPEN_TIME_FOR_PARKED_CALL');
        }
        else {
            if (this.Model.ReopenTime <= cDate) {
                this.AddError('ERR.ERR_REOPEN_DATE_GEATER_THAN_CURRENT_DATE');
            }
        }

        if (this.Model.IsAutoAssign == false && this.Model.AssignedTo == null) {
            this.AddError('ERR.ERR_SELECT_ASSIGNED_CALL_ON_REOPENING');
        }
    }

    ValidateReset(): void {
        if (this.Model.ClosedReasonCode == null || this.Model.ClosedReasonCode <= 0) {
            this.AddError('ERR.ERR_SELECT_RESET_REASON');
        }

        if (this.Reset_Hours == null && this.Reset_Minutes == null) {
            this.AddError('ERR.ERR_ENTER_EXTRA_TIME');
        }

        if (this.Reset_Hours != null && this.Reset_Hours < 0) {
            this.AddError('ERR.ERR_HOURS_LESS_THAN_0');
        }

        if (this.Reset_Minutes != null && this.Reset_Minutes < 0) {
            this.AddError('ERR.ERR_MIN_LESS_THAN_0');
        }

        if (this.Reset_Minutes != null && this.Reset_Hours != null && this.Reset_Hours <= 0 && this.Reset_Minutes <= 0) {
            this.AddError('ERR.ERR_ENTER_EXTRA_TIME');
        }
    }

    Validate(): void {
        switch (this.Model.Operation) {
            case JobOperationActions.Close:
                this.ValidateClose();
                break;
            case JobOperationActions.Park:
                this.ValidatePark();
                break;
            case JobOperationActions.AddRemarks:
                if (this.Model.Remarks == null || this.Model.Remarks.trim().length == 0) {
                    this.AddError('ERR.ERR_ENTER_REMARKS');
                }
                break;
            case JobOperationActions.Reset:
                this.ValidateReset();
                break;
            case JobOperationActions.Reopen:
                this.ValidateReopen();
                break;
        }
    }

    ValidateReopen(): void {
        if (this.Model.ClosedReasonCode == null || +this.Model.ClosedReasonCode <= 0) {
            this.AddError('ERR.ERR_SELECT_REOPEN_REASON');
        }
    }

    onResetHoursChanged(): void {
        if (this.Reset_Hours == null)
            this.Reset_Hours = 0;

        if (this.Reset_Hours < 0)
            this.Reset_Hours = 0;
    }

    onResetMinutesChanged(): void {
        if (this.Reset_Minutes == null)
            this.Reset_Minutes = 0;

        if (this.Reset_Minutes < 0)
            this.Reset_Minutes = 0;

        if (this.Reset_Minutes >= 60) {
            this.Reset_Minutes = 59;
        }
    }

    Transform_Request(): void {
        switch (this.Model.Operation) {
            case JobOperationActions.Close:
                this.Model.ClosedReasonCode = this.Model.ClosedReasonCode_Close;
                break;
            case JobOperationActions.Park:
                this.Model.ClosedReasonCode = this.Model.ClosedReasonCode_Park;
                if (this.Model.IsAutoAssign) {
                    this.Model.AssignedTo = null;
                }
                break;
            case JobOperationActions.Reset:
                if (this.Reset_Hours != null && this.Reset_Minutes != null) {
                    this.Model.ResetTime = (this.Reset_Hours * 60) + this.Reset_Minutes;
                }
                else {
                    this.Reset_Hours = null;
                }
                break;
            case JobOperationActions.Reopen:
                if (this.Model.IsAutoAssign == true) {
                    this.Model.AssignedTo = null;
                }
                break;
        }
    }

    onSubmit(): void {
        this.IsSubmitting = true;

        if (this.Model == null) {
            this.IsSubmitting = false;
            return;
        }
        
        this.ClearErrors();

        this.Transform_Request();

        this.Validate();

        if (this.HasErrors) {
            this.IsSubmitting = false;
            return;
        }

        let payloadModel: any;
        if(this.inventorySingularityEnabled && this.Model && this.Model.Operation == JobOperationActions.Close){
           if(this.Model.InventoryJobMappings && this.Model.InventoryJobMappings.ItemType){
            const mapping = { ...this.Model.InventoryJobMappings };

            mapping.ComplainId = this.Model.ComplainId;
            if(mapping.ItemType == "Consumables"){
                mapping['InventoryItemType'] =  InventoryItemTypes.Consumables;
            } else if(mapping.ItemType == "Reservables") {
                mapping['InventoryItemType'] =  InventoryItemTypes.Reservables;
            }
            if(this.guestInventoryDetail && this.guestInventoryDetail.GuestCheckInAt){
                mapping['InventoryCheckInAt'] = this.guestInventoryDetail.GuestCheckInAt;
            }
            if(this.guestInventoryDetail && this.guestInventoryDetail.GuestCheckOutAt){
                mapping['InventoryCheckOutAt'] = this.guestInventoryDetail.GuestCheckOutAt;
            }
            if( mapping && !mapping.StockLocationId){
                mapping['StockLocationId'] = 0;
            }
            mapping['InventoryTransactionType'] = InventoryTransactionTypes.Consume;
             delete mapping.Name;
             delete mapping.AvailableQuantity;
            //  this.Model.InventoryJobMappings = [this.Model.InventoryJobMappings];
              payloadModel = {
                    ...this.Model,
                    InventoryJobMappings: [mapping]
                };
            } else {
                 payloadModel = { ...this.Model };
                 delete payloadModel.InventoryJobMappings;
            }

        } else {
            payloadModel = { ...this.Model };
        }
        
        this.complainService.Complain_Update(payloadModel).then(data => {
            this.FromBaseResponse(data);
            if (this.HasErrors) {
                this.IsSubmitting = false;
                return;
            }
            this.IsSubmitting = false;
            if (this.Model.Operation != JobOperationActions.Reopen) {
                this.GetMultilingualToast('TS.TS_UPDATE_SUCCESS', 'success');
            }
            else {
                this.ConfirmModel = new Array(data.Result.OLTPData);
                this.ConfirmModalRef = this.modalService.open(this.confirm, { size: 'lg' });
            }
            this.ModalRef.close();

        }).catch(reason => {
            this.IsSubmitting = false;
        })
    }

    setInventoryItemType() {
         if(this.Model && this.Model.PropertyId && this.Model.CallDescriptionsId){
            let invData: any =  this.masterService.getInventoryDetailByPropertyDescription(this.Model.PropertyId, this.Model.CallDescriptionsId);
            if(invData && invData.ItemType){
                this.inventoryItempType = invData.ItemType;
            }else {
                this.inventoryItempType = '';
            }
        }
    }

}
